import axios from "axios";

const axiosConfig = axios.create({
  baseURL: process.env.GATSBY_REACT_APP_STRAPI_LIVE_URL,
});

export default axiosConfig;
